import { Body1 } from "./BodyCopy";
export default Body1;
export * from "./BodyCopy";
